import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ProblemItem } from "../../../models/types/problem";
import Loading from "../../../components/loading/loading";
import ProblemView from "./view";
import problemSvc from "../../../services/api/problem";
import { notify } from "../../../common/notificationService";

export default function ProblemViewPage() {
    const { id } = useParams<{ id?: string }>();

    const [data, setData] = useState<ProblemItem | null>(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (id) {
            getProblemById(id);
        }
    }, [id]);

    const getProblemById = async (id: string) => {
        setLoading(true);
        try {
            const res = await problemSvc.getProblemById(id);
            setData(res.content);
        } catch (error) {
            notify("Lỗi", "Xảy ra lỗi", "danger");
        } finally {
            setLoading(false);
        }
    }

    const handleUpdateStatus = (statusId: number) => {
        if (data && id) {
            problemSvc.updateProblemStatus({ id: data.id, status: statusId }).then(() => {
                notify("Thành công", "Cập nhật trạng thái thành công", "success");
                getProblemById(id);
            }).catch((e) => {
                notify("Lỗi", "Cập nhật trạng thái thất bại", "danger");
            });
        }
    }

    return (
        <div className="page-wrapper h-full">
            {loading ? <Loading /> : <ProblemView data={data} handleUpdateStatus={handleUpdateStatus} />}
        </div>
    );
}